import { Component } from '@angular/core';
import { NavController,NavParams,Events} from 'ionic-angular';

import { SelCalendarPage } from '../calendar/selcalendar';
import { RepeatPage } from '../repeat/repeat';
import { RepeatTimePage } from '../repeattime/repeattime';
import { RemindPage } from '../remind/remind';

import { TRIPSAVEORUPDATE } from '../../../providers/config/serviceurl';
import { WebService } from '../../../providers/service/webservice';
import { MAX_DATE,MIN_DATE,MOREORONE } from '../../../providers/config/constants';
import { Utils } from '../../../providers/service/utils';
import { StorageService } from '../../../providers/service/storageservice';
import { AppState } from '../../../app/app.global';
import { ToastAlert } from '../../../providers/util/toastalert';


@Component({
  selector: 'page-tripAdd',
  templateUrl: 'tripadd.html'
})
export class TripAddPage {
	tripList:any[];//当月或者当周具体日程数据
	currentUser:any;
	max_date = MAX_DATE;
	min_date = MIN_DATE;
	moreOrOne= MOREORONE;//more :表示连续多天  one:表示单一某天
	public trip = {
		id:'',
		title:'',
		posite:'',
    timeStarts: Utils.dateFormat(new Date(),'yyyy-MM-ddThh:mm'),
    timeEnds: Utils.dateFormat(new Date(),'yyyy-MM-ddThh:mm'),
    isAll:'0',
    isAll2:false,
    repeat:'永不',
    repeatValue:'0',
    endRepeatTime:'0',
    remind:'永不',
    remindValue:'0',
    calendarId:'',
    calendar:'选择日历',
    type:'',
    remark:'',
    bindingId:''
  }
	//过渡参数,应接  trip 中间数据
	data:any;

  constructor(public navCtrl: NavController,public params: NavParams
  		,public events: Events,private webService:WebService,public global: AppState,public toastAlert:ToastAlert) {
  	 this.data = params.data.trip;
  	 if(this.data){
  	 		this.trip = Utils.deepClone(this.data);
  	 }
  	 this.tripList = params.data.tripList;
  }


 	saveOrUpdateTrip(){
 		this.currentUser = StorageService.getObj("currentUser");
 		if(this.moreOrOne=='one'){
 			this.trip.timeEnds = this.trip.timeEnds.substr(11,5);
  	 		this.trip.timeEnds = this.trip.timeStarts.substr(0,10)+'T'+this.trip.timeEnds;
  	}
 		if(this.trip.title==''||this.trip.title==null){
 			this.toastAlert.alertMsg('标题不能为空','middle',1500);return;
 		}
 		if(this.trip.timeStarts==''||this.trip.timeStarts==null||this.trip.timeEnds==''||this.trip.timeEnds==null){
 			this.toastAlert.alertMsg('开始结束时间不能为空','middle',1500);return;
 		}
 		if(this.trip.calendarId==''||this.trip.calendarId==null){
 			this.toastAlert.alertMsg('请选择一个日历!','middle',1500);return;
 		}
 		if(this.trip.timeEnds<this.trip.timeStarts){
 			this.trip.timeEnds = this.trip.timeEnds.substr(11,5);
 			this.toastAlert.alertMsg('结束日期不能小于开始日期','middle',1500);return;
 		}
 		if(this.trip.endRepeatTime!='0'&&this.trip.endRepeatTime<=this.trip.timeEnds.substr(0,10)){
 			this.trip.timeEnds = this.trip.timeEnds.substr(11,5);
 			this.toastAlert.alertMsg('结束重复日期只能大于结束日期','middle',1500);return;
 		}
		var params = {'userId':this.currentUser.userId,
									'id':this.trip.id,
									'title':Utils.base64Encode(this.trip.title),
									'posite':Utils.base64Encode(this.trip.posite),
									'timeStarts':this.trip.timeStarts,
									'timeEnds':this.trip.timeEnds,
									'isAll':Utils.formatOneOrZreo(this.trip.isAll2),
									'repeatValue':this.trip.repeatValue,
									'endRepeatTime':this.trip.endRepeatTime,
									'remindValue':this.trip.remindValue,
									'calendarId':this.trip.calendarId,
									'type':this.trip.type,
									'remark':Utils.base64Encode(this.trip.remark),
									'bindingId':this.trip.bindingId
		};
		this.webService.post(TRIPSAVEORUPDATE,params,"日程新增更新").then(anyObj =>this.setCId(anyObj));
 	}

 	setCId(obj:any){
 		if(obj){
 			this.trip.isAll = Utils.formatOneOrZreo(this.trip.isAll2); //转换下,方便使用
 			if(this.trip.id==''||this.trip.id==null){
 				this.trip.id=obj.newId;
 			}else{
 				this.data.isBack=true;//返回之后重新获取值--影响修改页面
 				Utils.delArray(this.tripList,this.trip.id);
 			}
 			this.tripList.push(this.trip);
 			this.events.publish('popsuccess','pop success 666');
			this.toastAlert.alertMsg('保存成功','middle',1500);
			this.navCtrl.pop();
		}
 	}

  getRepeat() {
    this.navCtrl.push(RepeatPage, { trip: this.trip });
  }

  getEndRepeatTime(){
  	this.navCtrl.push(RepeatTimePage, { trip: this.trip });
  }

  getRemind() {
    this.navCtrl.push(RemindPage, { trip: this.trip });
  }

  getCalendar(){
  	this.navCtrl.push(SelCalendarPage, { trip: this.trip });
  }


}



// WEBPACK FOOTER //
// ./src/pages/trip/add/tripadd.ts